/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type FavoriteLineItemInput = {
  readonly favorited: boolean;
  readonly lineItemId: string | number;
  readonly productId: string | number;
};

export type FavoritedLineItemsInput = {
  readonly page: number;
};

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type ReorderFavoritesQueryVariables = Exact<{
  input: Types.FavoritedLineItemsInput;
}>;

export type ReorderFavoritesQuery = {
  readonly favoritedLineItems: ReadonlyArray<{
    readonly __typename: 'LineItem';
    readonly id: string;
    readonly customName: string | null;
    readonly quantity: number;
    readonly cost: number;
    readonly perItemCost: number;
    readonly favorited: boolean;
    readonly dressingMode: Types.DressingMode;
    readonly product: {
      readonly __typename: 'Product';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly enableDressingDetails: boolean;
      readonly categoryName: string;
      readonly asset: { readonly url: string };
      readonly ingredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
      }>;
    };
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly ingredientId: string;
      readonly weight: Types.DressingWeight;
    }>;
  }>;
};

export type ToggleReorderLineItemFavoriteStateMutationVariables = Exact<{
  input: Types.FavoriteLineItemInput;
}>;

export type ToggleReorderLineItemFavoriteStateMutation = {
  readonly favoriteLineItem: {
    readonly __typename: 'LineItem';
    readonly id: string;
    readonly favorited: boolean;
  };
};

export const ReorderFavoritesDocument = gql`
  query ReorderFavorites($input: FavoritedLineItemsInput!) {
    favoritedLineItems(input: $input) {
      id
      __typename
      customName
      quantity
      cost
      perItemCost
      favorited
      product {
        id
        __typename
        slug
        name
        isCustom
        enableDressingDetails
        categoryName
        asset {
          url
        }
        ingredients {
          id
          __typename
          name
          kind
        }
      }
      addedIngredients {
        id
        __typename
        name
        kind
      }
      removedIngredients {
        id
        __typename
        name
        kind
      }
      mixedDressingDetails {
        ingredientId
        weight
      }
      dressingMode
    }
  }
`;

export function useReorderFavoritesQuery(
  options: Omit<Urql.UseQueryArgs<ReorderFavoritesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderFavoritesQuery, ReorderFavoritesQueryVariables>({
    query: ReorderFavoritesDocument,
    ...options,
  });
}
export const ToggleReorderLineItemFavoriteStateDocument = gql`
  mutation ToggleReorderLineItemFavoriteState($input: FavoriteLineItemInput!) {
    favoriteLineItem(input: $input) {
      __typename
      id
      favorited
    }
  }
`;

export function useToggleReorderLineItemFavoriteStateMutation() {
  return Urql.useMutation<
    ToggleReorderLineItemFavoriteStateMutation,
    ToggleReorderLineItemFavoriteStateMutationVariables
  >(ToggleReorderLineItemFavoriteStateDocument);
}
